import { useEffect, useRef } from "react";
import { toast } from "sonner";

const currentMain = () => {
  const s = document.querySelector('script[src*="/static/js/main"]');
  return s ? s.getAttribute("src") : null;
};

/** Detects a newly deployed bundle and prompts users to refresh.
 *  Checks every 5 min + whenever the app regains focus (installed PWAs). */
export default function UpdateChecker() {
  const notified = useRef(false);
  useEffect(() => {
    const check = async () => {
      if (notified.current) return;
      const cur = currentMain();
      if (!cur) return;
      try {
        const r = await fetch("/asset-manifest.json", { cache: "no-store" });
        if (!r.ok) return;
        const m = await r.json();
        const latest = m.files && m.files["main.js"];
        if (latest && !cur.endsWith(latest)) {
          notified.current = true;
          toast.info("Firewatch has been updated — refresh to get the latest.", {
            duration: Infinity,
            action: { label: "Refresh now", onClick: () => window.location.reload() },
          });
        }
      } catch { /* offline — try again next cycle */ }
    };
    const id = setInterval(check, 5 * 60 * 1000);
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    const t = setTimeout(check, 20000);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
      clearTimeout(t);
    };
  }, []);
  return null;
}
